module.exports = "pegasus/assets/background-patterns/light-gray.png";